import { api } from "@/shared/libs/axiosClient";
import type {
    GetOnboardingInfoResponse,
    StartOnboardingRequest,
} from "../types/onboarding-types";

/**
 * 온보딩에 필요한 정보 조회
 * @returns 온보딩 가능한 조직 목록
 */
export async function getOnboardingInfo(): Promise<GetOnboardingInfoResponse> {
    return api.get<GetOnboardingInfoResponse>("/organizations/onboarding/info");
}

/**
 * 조직 온보딩 시작
 */
export async function startOnboarding(request: StartOnboardingRequest): Promise<void> {
    return api.post("/organizations/onboarding/start", request);
}
